const pending = new Map<string, Promise<void>>()

/**
 * Injects a module script tag and resolves once it has loaded — the same thing the
 * customer-facing GTM install snippet does. Deduplicated by src so repeated calls
 * (page-load injection + Initialize button) share one script tag.
 */
export const injectScript = (src: string): Promise<void> => {
  const existing = pending.get(src)
  if (existing) return existing

  const promise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.type = 'module'
    script.async = true
    script.crossOrigin = 'anonymous'
    script.onload = () => resolve()
    script.onerror = () => {
      pending.delete(src)
      script.remove()
      reject(new Error(`Failed to load script: ${src}`))
    }
    ;(document.head || document.documentElement).appendChild(script)
  })
  pending.set(src, promise)
  return promise
}
